var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-btn',{staticClass:"auth-btn white--text",attrs:{"color":"mainNew"},on:{"click":_vm.openAuthWindow}},[_vm._v("Войти")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }